import dayjs from "dayjs";
import { WeekDayEnum } from "../gql/graphql.ts";

export const onboardingLiveTimezone = "Europe/Rome";

export const weekDaysInOrder: { weekDay: WeekDayEnum; label: string }[] = [
  { weekDay: WeekDayEnum.Monday, label: "Lun" },
  { weekDay: WeekDayEnum.Tuesday, label: "Mar" },
  { weekDay: WeekDayEnum.Wednesday, label: "Mer" },
  { weekDay: WeekDayEnum.Thursday, label: "Gio" },
  { weekDay: WeekDayEnum.Friday, label: "Ven" },
  { weekDay: WeekDayEnum.Saturday, label: "Sab" },
  { weekDay: WeekDayEnum.Sunday, label: "Dom" },
];

const weekDayByDayjsDay: WeekDayEnum[] = [
  WeekDayEnum.Sunday,
  WeekDayEnum.Monday,
  WeekDayEnum.Tuesday,
  WeekDayEnum.Wednesday,
  WeekDayEnum.Thursday,
  WeekDayEnum.Friday,
  WeekDayEnum.Saturday,
];

export type UserGroupAvailability = {
  weekDay: WeekDayEnum;
  timeIntervals: { from: number; to: number }[];
}[];

const allHours = Array.from({ length: 24 }, (_, i) => i);

export function weekDayOf(date: string): WeekDayEnum {
  return weekDayByDayjsDay[dayjs.tz(date, onboardingLiveTimezone).day()];
}

export function bookableHoursOf(
  availability: UserGroupAvailability | null | undefined,
  weekDays: WeekDayEnum[],
): number[] {
  if (!availability) return allHours;
  const hours = availability
    .filter((a) => weekDays.includes(a.weekDay))
    .flatMap((a) =>
      a.timeIntervals.flatMap((ti) =>
        allHours.filter((h) => h >= ti.from && h + 1 <= ti.to),
      ),
    );
  return [...new Set(hours)].sort((a, b) => a - b);
}

export function toStartUtc(date: string, hour: number): string {
  return dayjs
    .tz(`${date} ${String(hour).padStart(2, "0")}:00`, onboardingLiveTimezone)
    .toISOString();
}

export function formatHour(hour: number): string {
  return `${String(hour).padStart(2, "0")}:00`;
}

export function formatSlot(startUtc: string): string {
  return dayjs(startUtc)
    .tz(onboardingLiveTimezone)
    .locale("it")
    .format("ddd DD/MM/YYYY HH:mm");
}
